import React from "react"
import OrangeCropped from "./QarabaoHorizontalOrange.png"
import "./HorizontalLogo.css"

function HorizontalLogo({ onClick }) {
  return (
    <div className="HorizontalLogo" onClick={onClick}>
      <img src={OrangeCropped} alt="Qarabao" />
    </div>
  )
}

export default HorizontalLogo
